export const CART_LOADING = 'CART_LOADING';
export const CART_FULFILLED = 'CART_FULFILLED';
export const CARTS_FULFILLED = 'CARTS_FULFILLED';
